import { Fragment } from 'react';

import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';

import Badge from '@webclient/components/upgrade-modal/components/card/key-features/badge';
import {
  StyledListItem,
  StyledListItemIcon,
  StyledWrapStack,
} from '@webclient/components/upgrade-modal/components/card/key-features/styles';

import CheckAltRounded from '~icons/knowz-iconify/check-alt-rounded';
import StarIcon from '~icons/knowz-iconify/star';

import { Text } from '@knowz/knowz-ui';

type Props = {
  keys: string[];
  boldFeature: string;
  badges: React.ReactNode[];
};

export default function KeyFeatures({ keys, boldFeature, badges }: Props) {
  return (
    <StyledListItem disablePadding>
      <Stack
        gap={2}
        sx={{ width: '100%' }}
      >
        <Stack
          gap={2}
          sx={{ alignItems: 'flex-start', mb: 4 }}
        >
          <Stack
            direction="row"
            gap={2.5}
          >
            <StyledListItemIcon>
              <StarIcon />
            </StyledListItemIcon>
            <Text
              variant="textMd"
              weight="semibold"
            >
              {boldFeature}
            </Text>
          </Stack>
          <StyledWrapStack>
            {badges.map((badge, index) => (
              <Badge
                key={index}
                size="small"
                variant="filled"
                label={badge}
                color="primary"
              />
            ))}
          </StyledWrapStack>
        </Stack>
        {keys.map((key, index) => (
          <Fragment key={key}>
            <Stack
              direction="row"
              gap={2.5}
              sx={{ alignItems: 'flex-start' }}
            >
              <StyledListItemIcon>
                <CheckAltRounded fontSize="0.6em" />
              </StyledListItemIcon>
              <ListItemText
                primaryTypographyProps={{
                  variant: index === 0 ? 'textSm' : 'textMd',
                  fontWeight: index === 0 ? 600 : 500,
                }}
                primary={key}
              />
            </Stack>
          </Fragment>
        ))}
      </Stack>
    </StyledListItem>
  );
}
